import { Component, Input } from '@angular/core';

@Component({
  selector: 'mprd-loading-modal',
  templateUrl: './loading-modal.component.html',
})
export class LoadingModalComponent {
  @Input() message = '';
}
